const localHostnames = ["localhost", "127.0.0.1", "::1"];

export const shouldAttemptMultipass = hostname =>
  !localHostnames.includes(hostname);
